import { useTheme } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Celebration = () => {
  var {
    colors
  } = useTheme();
  return /*#__PURE__*/_jsxs("svg", {
    height: "100%",
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "72",
      cy: "72",
      r: "54",
      fill: colors.illustration.light
    }), /*#__PURE__*/_jsx("path", {
      d: "M30.7298 113.998C29.0421 114.776 27.2985 113.032 28.0763 111.345L60.1821 41.6811C60.7648 40.4169 62.4285 40.1197 63.4127 41.104L100.97 78.6617C101.955 79.646 101.658 81.3097 100.393 81.8923L30.7298 113.998Z",
      fill: colors.illustration.bg
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M31.5669 115.815C28.1915 117.37 24.7043 113.883 26.2599 110.508L58.3657 40.8442C59.531 38.3158 62.8584 37.7214 64.8269 39.69L102.385 77.2477C104.353 79.2162 103.759 82.5436 101.23 83.7089L31.5669 115.815ZM61.9985 42.5184L29.8927 112.182L99.5562 80.0761L61.9985 42.5184Z",
      fill: colors.illustration.stroke
    }), /*#__PURE__*/_jsx("path", {
      d: "M55.1809 57.0315L48.1766 72.2198L94.0624 74.4402L78.8156 59.1838L55.1809 57.0315Z",
      fill: colors.illustration.main
    }), /*#__PURE__*/_jsx("path", {
      d: "M42.0991 85.4441L35.0144 100.819L52.9545 101.658L82.3621 88.0998L42.0991 85.4441Z",
      fill: colors.illustration.main
    }), /*#__PURE__*/_jsx("path", {
      d: "M104.863 6L110.082 8.73681L108.307 18.8307L103.735 18.2421L104.863 6Z",
      fill: colors.illustration.main
    }), /*#__PURE__*/_jsx("path", {
      d: "M123.865 27.7374L121.373 23.4605L132.183 17.1726L135.028 20.498L123.865 27.7374Z",
      fill: colors.illustration.main
    }), /*#__PURE__*/_jsx("path", {
      d: "M127.426 43.1778V38.9009L135.862 36.7625L138 41.0394L127.426 43.1778Z",
      fill: colors.illustration.main
    }), /*#__PURE__*/_jsx("path", {
      d: "M85.9854 46.8047H89.7521L90.8508 56.1531L86.466 56.7809L85.9854 46.8047Z",
      fill: colors.illustration.main
    }), /*#__PURE__*/_jsx("path", {
      d: "M108.959 63.3136L112.049 66.9922L120.014 57.1337L115.973 53.3276L108.959 63.3136Z",
      fill: colors.illustration.main
    }), /*#__PURE__*/_jsx("path", {
      d: "M113.835 39.0747L116.444 42.9985L107.302 46.8045L105.634 44.3031L113.835 39.0747Z",
      fill: colors.illustration.main
    }), /*#__PURE__*/_jsx("path", {
      d: "M77.6619 31.2982H82.5274L85.3819 19.5465L81.2227 17.1726L77.6619 31.2982Z",
      fill: colors.illustration.main
    })]
  });
};
//# sourceMappingURL=Celebration.js.map